export const DEFAULT_FAMILY = '"Roboto", "Helvetica", "Arial", sans-serif'
export const HTML_FONT_SIZE = 16
export const FONT_SIZE = 14
export const COEF = FONT_SIZE / 14
